import { adminProfileStatistics } from "@api/system/adminProfileStatistics/path";
import { memberProfileStatistics } from "@api/system/memberProfileStatistics/path";
import { publicStatistics } from "@api/system/publicStatistics/path";
import { staffProfileStatistics } from "@api/system/staffProfileStatistics/path";

export const system = {
  adminProfileStatistics,
  memberProfileStatistics,
  publicStatistics,
  staffProfileStatistics,
};
